import _ from 'lodash'

export const availableColorsByColors = state => {
  return _.keyBy(state.availableColorSchemes, 'color')
}

export const availableColorSchemeByColor = state => color => {
  const availableColorSchemesByColor = _.keyBy(state.availableColorSchemes, 'color')
  return _.get(availableColorSchemesByColor, color, {
    title: 'Unknown',
    color: '#ffffff'
  })
}



// WEBPACK FOOTER //
// ./src/store/getters/common.js